export const bp = {
    phablet: "screen and (min-width: 500px)", 
    tablet: "screen and (min-width: 700px)",
    laptop: "screen and (min-width: 1000px)",
    desktop: "screen and (min-width: 1280px)",
}